(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const cartContent = document.querySelector('[data-cart-content]');
  const openers = document.querySelectorAll('[data-cart-open]');
  const closers = document.querySelectorAll('[data-cart-close]');

  // JOYANA search overlay keeps the current page visible beneath a soft blur.
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchInput = document.querySelector('[data-search-input]');
  const closeSearch = () => {
    document.body.classList.remove('search-open');
    searchOverlay?.setAttribute('aria-hidden', 'true');
  };
  document.querySelectorAll('[data-search-open]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    document.body.classList.add('search-open');
    searchOverlay?.setAttribute('aria-hidden', 'false');
    window.setTimeout(() => searchInput?.focus(), 120);
  }));
  document.querySelectorAll('[data-search-close]').forEach(button => button.addEventListener('click', closeSearch));

  // Keep search, navigation and cart within reach while the page scrolls.
  const siteHeader = document.querySelector('[data-sticky-header]');
  const syncMobileMenuTop = () => {
    if (!siteHeader) return;
    const headerBottom = Math.max(0, Math.round(siteHeader.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--joyana-mobile-menu-top', `${headerBottom}px`);
  };
  syncMobileMenuTop();
  window.addEventListener('resize', syncMobileMenuTop, { passive: true });
  window.addEventListener('scroll', syncMobileMenuTop, { passive: true });
  if ('ResizeObserver' in window && siteHeader) new ResizeObserver(syncMobileMenuTop).observe(siteHeader);

  if (siteHeader?.dataset.stickyHeader === 'true') {
    const stickyContainer = siteHeader.closest('.shopify-section') || siteHeader;
    stickyContainer.classList.add('joyana-header-section--sticky');
    const updateStickyHeader = () => {
      const shouldCompact = siteHeader.dataset.collapseAnnouncement === 'true' && window.scrollY > 32;
      stickyContainer.classList.toggle('joyana-header-section--scrolled', shouldCompact);
    };
    updateStickyHeader();
    window.addEventListener('scroll', updateStickyHeader, { passive: true });
  }

  const escapeHtml = value => String(value).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const formatMoney = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  const openDrawer = () => { drawer?.setAttribute('aria-hidden', 'false'); document.body.classList.add('drawer-open'); };
  const closeDrawer = () => { drawer?.setAttribute('aria-hidden', 'true'); document.body.classList.remove('drawer-open'); };

  let recsCache = null;
  function renderRecs() {
    if (recsCache !== null) return recsCache;
    const tpl = document.getElementById('JoyanaCartRecs');
    const cards = tpl ? tpl.innerHTML.trim() : '';
    recsCache = cards
      ? '<div class="cart-recs"><p>' + (window.JOYANA_RECS_LABEL || 'YOU MIGHT LIKE') + '</p><div class="cart-recs__viewport"><div class="cart-recs__track">' + cards + cards + '</div></div></div>'
      : '';
    return recsCache;
  }

  async function renderCart() {
    if (!cartContent) return;
    const cart = await fetch('/cart.js').then(response => response.json());
    const counter = document.querySelector('[data-cart-count]');
    if (counter) counter.textContent = `(${cart.item_count})`;
    if (!cart.item_count) {
      cartContent.innerHTML = '<p class="cart-empty">Your cart is empty.</p><a class="button button--dark" href="/collections/all">CONTINUE SHOPPING</a>' + renderRecs();
      return;
    }
    const savings = cart.items.reduce((sum, item) => sum + Math.max(0, item.original_line_price - item.final_line_price), 0);
    const lines = cart.items.map((item, i) => '<article class="cart-line cart-line--drawer" data-key="' + item.key + '">'
      + '<a class="cart-line__media" href="' + item.url + '">' + (item.image ? '<img src="' + item.image + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '">' : '') + '</a>'
      + '<div class="cart-line__info">'
        + '<a class="cart-line__title-link" href="' + item.url + '"><h3 class="cart-line__title">' + item.product_title + '</h3></a>'
        + (item.variant_title ? '<p class="cart-line__variant">' + item.variant_title + '</p>' : '')
        + '<p class="cart-line__unit">'
          + (item.original_price > item.final_price ? '<s class="cart-line__compare">' + formatMoney(item.original_price) + '</s> ' : '')
          + formatMoney(item.final_price) + ' each</p>'
        + (item.line_level_discount_allocations || []).filter(d => d.amount > 0).map(d => '<p class="cart-line__discount">' + escapeHtml(d.discount_application?.title || 'Discount') + ' &middot; &minus;' + formatMoney(d.amount) + '</p>').join('')
        + '<button class="cart-line__remove" type="button" data-cart-remove="' + item.key + '">REMOVE</button>'
      + '</div>'
      + '<div class="cart-line__qty"><label class="visually-hidden" for="DrawerQty-' + i + '">Quantity</label>'
        + '<div class="qty-stepper qty-stepper--drawer">'
          + '<button class="qty-stepper__btn" type="button" data-drawer-step="-1" data-key="' + item.key + '" aria-label="Decrease quantity">&minus;</button>'
          + '<input id="DrawerQty-' + i + '" type="number" min="0" inputmode="numeric" value="' + item.quantity + '" data-drawer-qty data-key="' + item.key + '">'
          + '<button class="qty-stepper__btn" type="button" data-drawer-step="1" data-key="' + item.key + '" aria-label="Increase quantity">+</button>'
        + '</div></div>'
      + '<p class="cart-line__price">' + formatMoney(item.final_line_price) + '</p>'
    + '</article>').join('');

    cartContent.innerHTML = '<div class="cart-lines cart-lines--drawer">' + lines + '</div>'
      + '<div class="cart-summary cart-summary--drawer">'
        + '<div class="cart-summary__row"><span>SUBTOTAL</span><strong>' + formatMoney(cart.total_price) + '</strong></div>'
        + (savings > 0 ? '<p class="cart-summary__savings">You\'re saving ' + formatMoney(savings) + '</p>' : '')
        + '<p class="cart-summary__note"><span class="cart-summary__free">FREE SHIPPING</span> &middot; Tax calculated at checkout</p>'
        + '<a class="button button--rust cart-summary__checkout" href="/checkout">CHECK OUT</a>'
        + '<a class="text-link cart-summary__continue" href="/cart">VIEW FULL CART &#8594;</a>'
      + '</div>';
  }
  let drawerPending = null;
  cartContent?.addEventListener('input', event => {
    const input = event.target.closest('[data-drawer-qty]');
    if (!input) return;
    clearTimeout(drawerPending);
    drawerPending = setTimeout(async () => {
      cartContent.setAttribute('data-busy', 'true');
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: input.dataset.key, quantity: Math.max(0, Number(input.value) || 0) })
        });
        await renderCart();
      } finally {
        cartContent.removeAttribute('data-busy');
      }
    }, 450);
  });

  cartContent?.addEventListener('click', async event => {
    const step = event.target.closest('[data-drawer-step]');
    if (step) {
      const input = cartContent.querySelector('[data-drawer-qty][data-key="' + step.dataset.key + '"]');
      if (input) {
        input.value = Math.max(0, (Number(input.value) || 0) + Number(step.dataset.drawerStep));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      return;
    }

    const remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    remove.disabled = true;
    remove.textContent = 'REMOVING…';
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 })
      });
      await renderCart();
    } catch (error) {
      remove.disabled = false;
      remove.textContent = 'REMOVE';
    }
  });

  openers.forEach(button => button.addEventListener('click', async () => { await renderCart(); openDrawer(); }));
  closers.forEach(button => button.addEventListener('click', closeDrawer));
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    closeDrawer();
    closeSearch();
    document.body.classList.remove('menu-open');
    document.querySelector('.joyana-menu-panel')?.setAttribute('aria-hidden', 'true');
  });

  document.querySelectorAll('[data-product-form]').forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const defaultLabel = button?.dataset.defaultLabel || button?.textContent || 'ADD TO CART';
    if (button) { button.disabled = true; button.textContent = 'ADDING…'; }
    const formData = new FormData(form);
    const result = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(formData.get('id')), quantity: Number(formData.get('quantity')) || 1 }] }) });
    if (result.ok) { await renderCart(); openDrawer(); }
    if (button) { button.disabled = false; button.textContent = result.ok ? defaultLabel : 'TRY AGAIN'; }
  }));

  // Quick add cards require an explicit size choice so the first size is never added by accident.
  document.querySelectorAll('[data-quick-add-variant]').forEach(select => {
    const form = select.closest('[data-product-form]');
    const button = form?.querySelector('button[type="submit"]');
    if (!button) return;
    const card = select.closest('.product-card');
    const priceEl = card?.querySelector('[data-price-target]');
    const syncQuickAdd = () => {
      button.disabled = !select.value;
      if (!priceEl) return;
      const picked = select.options[select.selectedIndex];
      const variantPrice = picked?.dataset.variantPrice;
      priceEl.textContent = select.value && variantPrice ? variantPrice : (priceEl.dataset.priceRange || priceEl.textContent);
    };
    select.addEventListener('change', syncQuickAdd);
    syncQuickAdd();
  });

  // Cart page: changing a quantity updates the cart immediately, no Update button needed
  const cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    const updateBtn = cartForm.querySelector('[data-cart-update]');
    if (updateBtn) updateBtn.hidden = true;

    const inputs = [...cartForm.querySelectorAll('[data-cart-qty]')];
    let pending = null;

    const applyChange = async input => {
      const line = Number(input.dataset.line);
      const quantity = Math.max(0, Number(input.value) || 0);
      cartForm.setAttribute('data-busy', 'true');
      try {
        const res = await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity })
        });
        if (!res.ok) throw new Error('Cart update failed');
        const cart = await res.json();

        if (quantity === 0 || cart.items.length !== inputs.length) { window.location.reload(); return; }

        const rowsSelector = '.cart-line';
        const totalEl = cartForm.querySelector('[data-cart-total]');
        const money = cents => {
          const format = window.Shopify?.currency?.active || '';
          const value = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return format === 'USD' || !format ? '$' + value : value + ' ' + format;
        };
        if (totalEl) totalEl.textContent = money(cart.total_price);
        cart.items.forEach((item, i) => {
          const row = inputs[i]?.closest(rowsSelector);
          const priceEl = row?.querySelector('[data-line-price]');
          if (priceEl) priceEl.textContent = money(item.final_line_price);
          if (inputs[i]) inputs[i].value = item.quantity;
        });
      } catch (error) {
        window.location.reload();
      } finally {
        cartForm.removeAttribute('data-busy');
      }
    };

    inputs.forEach(input => {
      const queue = () => { clearTimeout(pending); pending = setTimeout(() => applyChange(input), 450); };
      input.addEventListener('change', queue);
      input.addEventListener('input', queue);
    });

    cartForm.querySelectorAll('[data-qty-step]').forEach(button => {
      button.addEventListener('click', () => {
        const input = document.getElementById(button.dataset.target);
        if (!input) return;
        const next = Math.max(0, (Number(input.value) || 0) + Number(button.dataset.qtyStep));
        input.value = next;
        clearTimeout(pending);
        applyChange(input);
      });
    });

    cartForm.querySelectorAll('[data-cart-line-remove]').forEach(button => {
      button.addEventListener('click', () => {
        const input = cartForm.querySelector('[data-cart-qty][data-line="' + button.dataset.line + '"]');
        if (!input) return;
        input.value = 0;
        clearTimeout(pending);
        applyChange(input);
      });
    });
  }

  document.querySelectorAll('[data-menu-toggle]').forEach(button => button.addEventListener('click', () => {
    syncMobileMenuTop();
    document.body.classList.toggle('menu-open');
    button.setAttribute('aria-expanded', document.body.classList.contains('menu-open') ? 'true' : 'false');
    var panel = document.querySelector('.joyana-menu-panel');
    if (panel) {
      if (document.body.classList.contains('menu-open')) { panel.classList.add('menu-active'); panel.setAttribute('aria-hidden', 'false'); }
      else { panel.classList.remove('menu-active'); panel.setAttribute('aria-hidden', 'true'); }
    }
  }));
  document.querySelectorAll('.joyana-menu-panel a').forEach(link => link.addEventListener('click', () => {
    document.body.classList.remove('menu-open');
    document.querySelector('.joyana-menu-panel')?.setAttribute('aria-hidden', 'true');
  }));

  // Editorial image/video hero slider. It pauses on interaction and honours reduced motion.
  document.querySelectorAll('[data-hero-slider]').forEach(slider => {
    const slides = [...slider.querySelectorAll('[data-hero-slide]')];
    if (slides.length < 2) return;
    const dots = [...slider.querySelectorAll('[data-hero-dot]')];
    const currentLabel = slider.querySelector('[data-hero-current]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = slider.dataset.autoplay === 'true' && !reducedMotion;
    const interval = Math.max(5000, Number(slider.dataset.interval) || 7000);
    let index = 0;
    let timer;
    let touchStart = 0;

    const syncVideo = slide => {
      slides.forEach(item => {
        const video = item.querySelector('.home-hero__video');
        if (!video) return;
        if (item === slide) video.play().then(() => video.classList.add('is-playing')).catch(() => {});
        else { video.pause(); video.classList.remove('is-playing'); }
      });
    };
    const show = nextIndex => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
      if (currentLabel) currentLabel.textContent = String(index + 1).padStart(2, '0');
      syncVideo(slides[index]);
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (autoplay) timer = window.setInterval(() => show(index + 1), interval);
    };
    slider.querySelector('[data-hero-prev]')?.addEventListener('click', () => { show(index - 1); start(); });
    slider.querySelector('[data-hero-next]')?.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach(dot => dot.addEventListener('click', () => { show(Number(dot.dataset.heroDot)); start(); }));
    slider.addEventListener('pointerenter', stop);
    slider.addEventListener('pointerleave', start);
    slider.addEventListener('touchstart', event => { touchStart = event.changedTouches[0].clientX; stop(); }, { passive: true });
    slider.addEventListener('touchend', event => {
      const delta = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(delta) > 45) show(index + (delta < 0 ? 1 : -1));
      start();
    }, { passive: true });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    show(0);
    start();
  });

  // Collection strip: horizontal scroll with arrow buttons and swipe
  document.querySelectorAll('[data-scroll-track]').forEach(track => {
    const section = track.closest('section[data-layout]');
    const prev = section?.querySelector('.collection-strip__arrow--prev');
    const next = section?.querySelector('.collection-strip__arrow--next');
    const step = () => Math.min(460, track.clientWidth * 0.75);
    const updateArrows = () => {
      const overflow = track.scrollWidth > track.clientWidth + 4;
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (prev) {
        prev.style.display = overflow ? '' : 'none';
        prev.style.opacity = atStart ? '.35' : '1';
        prev.disabled = !overflow || atStart;
      }
      if (next) {
        next.style.display = overflow ? '' : 'none';
        next.style.opacity = atEnd ? '.35' : '1';
        next.disabled = !overflow || atEnd;
      }
    };
    prev?.addEventListener('click', () => { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next?.addEventListener('click', () => { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    let startX = 0; let startScroll = 0; let dragging = false;
    track.addEventListener('pointerdown', event => { startX = event.pageX; startScroll = track.scrollLeft; dragging = true; track.style.scrollBehavior = 'auto'; }, { passive: true });
    window.addEventListener('pointermove', event => { if (!dragging) return; track.scrollLeft = startScroll - (event.pageX - startX); }, { passive: true });
    window.addEventListener('pointerup', () => { if (!dragging) return; dragging = false; track.style.scrollBehavior = ''; updateArrows(); });
    window.addEventListener("resize", updateArrows);
    updateArrows();
  });

  // Product micro-poll. Tap order becomes rank 1–3 and is stored as a cart attribute.
  const initProductPolls = (scope = document) => {
    const polls = [
      ...(scope.matches?.('[data-product-poll]') ? [scope] : []),
      ...scope.querySelectorAll('[data-product-poll]')
    ];
    polls.forEach(poll => {
      if (poll.dataset.initialised === 'true') return;
      poll.dataset.initialised = 'true';
      const form = poll.querySelector('[data-product-poll-form]');
      const choices = [...poll.querySelectorAll('[data-product-poll-choice]')];
      const submit = form?.querySelector('button[type="submit"]');
      const status = poll.querySelector('[data-product-poll-status]');
      const maxChoices = Math.max(1, Number(poll.dataset.maxChoices) || 3);
      const handle = poll.dataset.productHandle || 'product';
      const storageKey = `joyana-product-poll:${handle}`;
      const submitLabel = submit?.textContent || 'SHARE YOUR POINT OF VIEW ↗';
      let selected = [];
      if (!form || !submit || !choices.length) return;

      const sync = () => {
        selected = selected.filter(choice => choice.checked);
        choices.forEach(choice => {
          const rank = selected.indexOf(choice);
          const option = choice.closest('.product-poll__option');
          option?.setAttribute('data-selected', String(rank > -1));
          const rankLabel = option?.querySelector('.product-poll__rank');
          if (rankLabel) rankLabel.textContent = rank > -1 ? String(rank + 1) : '';
        });
        submit.disabled = selected.length === 0;
      };

      try {
        const saved = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        saved.slice(0, maxChoices).forEach(value => {
          const choice = choices.find(input => input.value === value);
          if (choice) { choice.checked = true; selected.push(choice); }
        });
      } catch (error) {}
      sync();

      choices.forEach(choice => choice.addEventListener('change', () => {
        if (choice.checked) {
          if (selected.length >= maxChoices) {
            choice.checked = false;
            if (status) status.textContent = `Choose up to ${maxChoices}.`;
          } else {
            selected.push(choice);
            if (status) status.textContent = '';
          }
        } else {
          selected = selected.filter(item => item !== choice);
          if (status) status.textContent = '';
        }
        sync();
      }));

      form.addEventListener('submit', async event => {
        event.preventDefault();
        const values = selected.map(choice => choice.value);
        if (!values.length) return;
        submit.disabled = true;
        submit.textContent = 'SAVING…';
        if (status) status.textContent = '';
        try {
          window.localStorage.setItem(storageKey, JSON.stringify(values));
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { [`JOYANA poll - ${handle}`]: values.join(' > ') } })
          });
          if (!response.ok) throw new Error('Cart attribute update failed');

          // Optional external collector: Google Form or plain webhook
          const endpoint = poll.dataset.endpoint;
          if (endpoint) {
            const answer = values.join(' > ');
            if (endpoint.includes('docs.google.com')) {
              const body = new URLSearchParams();
              body.append(poll.dataset.endpointField || 'entry.1', answer);
              fetch(endpoint, { method: 'POST', mode: 'no-cors', body }).catch(() => {});
            } else {
              fetch(endpoint, {
                method: 'POST',
                mode: 'no-cors',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  product: handle,
                  product_title: poll.dataset.productTitle || handle,
                  answers: values,
                  answer,
                  submitted_at: new Date().toISOString()
                })
              }).catch(() => {});
            }
          }

          if (window.Shopify?.analytics?.publish) {
            window.Shopify.analytics.publish('joyana_product_poll_submitted', {
              product_id: poll.dataset.productId,
              product_handle: handle,
              choices: values
            });
          }
          if (status) status.textContent = poll.dataset.successMessage;
        } catch (error) {
          if (status) status.textContent = poll.dataset.errorMessage;
        } finally {
          submit.disabled = false;
          submit.textContent = submitLabel;
        }
      });
    });
  };
  initProductPolls();
  document.addEventListener('shopify:section:load', event => initProductPolls(event.target));



  // Gallery lightbox: click a product image to enlarge, arrows/keys to move between them
  const initProductZoom = (scope = document) => {
    const galleries = [
      ...(scope.matches?.('[data-product-zoom]') ? [scope] : []),
      ...scope.querySelectorAll('[data-product-zoom]')
    ];
    if (!galleries.length) return;

    let box = document.querySelector('.joyana-lightbox');
    if (!box) {
      box = document.createElement('div');
      box.className = 'joyana-lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Product image');
      box.innerHTML =
        '<img alt="">' +
        '<button class="joyana-lightbox__close" type="button" aria-label="Close">\u2715</button>' +
        '<button class="joyana-lightbox__nav" data-dir="prev" type="button" aria-label="Previous image">\u2190</button>' +
        '<button class="joyana-lightbox__nav" data-dir="next" type="button" aria-label="Next image">\u2192</button>' +
        '<span class="joyana-lightbox__count"></span>';
      document.body.appendChild(box);
    }

    const figure = box.querySelector('img');
    const count = box.querySelector('.joyana-lightbox__count');
    const navs = [...box.querySelectorAll('.joyana-lightbox__nav')];
    let sources = [];
    let index = 0;
    let opener = null;

    const pad = n => String(n).padStart(2, '0');
    const show = () => {
      const item = sources[index];
      if (!item) return;
      figure.src = item.src;
      figure.alt = item.alt;
      if (count) count.textContent = pad(index + 1) + ' / ' + pad(sources.length);
      navs.forEach(n => { n.style.display = sources.length > 1 ? 'grid' : 'none'; });
    };
    const move = step => { index = (index + step + sources.length) % sources.length; show(); };
    const close = () => {
      box.dataset.open = 'false';
      document.documentElement.style.overflow = '';
      if (opener) opener.focus();
    };
    const open = (list, start, trigger) => {
      sources = list;
      index = start;
      opener = trigger;
      show();
      box.dataset.open = 'true';
      document.documentElement.style.overflow = 'hidden';
      box.querySelector('.joyana-lightbox__close').focus();
    };

    box.querySelector('.joyana-lightbox__close').addEventListener('click', close);
    navs.forEach(n => n.addEventListener('click', () => move(n.dataset.dir === 'next' ? 1 : -1)));
    box.addEventListener('click', event => { if (event.target === box || event.target === figure) close(); });
    document.addEventListener('keydown', event => {
      if (box.dataset.open !== 'true') return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowRight') move(1);
      if (event.key === 'ArrowLeft') move(-1);
    });

    galleries.forEach(gallery => {
      if (gallery.dataset.zoomReady === 'true') return;
      gallery.dataset.zoomReady = 'true';
      const images = [...gallery.querySelectorAll('img')];
      images.forEach((img, i) => {
        img.setAttribute('role', 'button');
        img.setAttribute('tabindex', '0');
        const list = () => images.map(el => ({
          src: el.currentSrc || el.src,
          alt: el.alt || ''
        }));
        img.addEventListener('click', () => open(list(), i, img));
        img.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(list(), i, img); }
        });
      });
    });
  };
  initProductZoom();
  document.addEventListener('shopify:section:load', event => initProductZoom(event.target));


  // Read more: product description truncated to N lines, READ MORE / READ LESS toggle
  document.querySelectorAll('[data-read-more]').forEach(block => {
    const description = block.querySelector('.product-description');
    const button = block.querySelector('.read-more-button');
    if (!description || !button) return;
    const lines = Number(block.dataset.readMoreLines) || 2;
    const moreLabel = block.dataset.readMoreLabel || 'READ MORE';
    const lessLabel = block.dataset.readLessLabel || 'READ LESS';
    const getLineHeight = () => parseFloat(getComputedStyle(description).lineHeight) || parseFloat(getComputedStyle(description).fontSize) * 1.3;
    const setCollapsed = () => { description.style.maxHeight = `${getLineHeight() * lines}px`; };
    let initialised = false;
    const init = () => {
      if (initialised) return;
      initialised = true;
      description.style.overflow = 'hidden';
      setCollapsed();
      button.setAttribute('aria-expanded', 'false');
      button.textContent = moreLabel;
    };
    init();
    window.addEventListener('resize', () => { if (button.getAttribute('aria-expanded') !== 'true') setCollapsed(); });
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        description.style.maxHeight = `${getLineHeight() * lines}px`;
        button.setAttribute('aria-expanded', 'false');
        button.textContent = moreLabel;
        setTimeout(() => { description.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 320);
      } else {
        description.style.maxHeight = `${description.scrollHeight}px`;
        button.setAttribute('aria-expanded', 'true');
        button.textContent = lessLabel;
      }
    });
  });
  // Sticky add-to-cart on mobile: show after hero/gallery, sync with the main form button
  const sticky = document.querySelector('[data-sticky-atc]');
  if (sticky && window.matchMedia('(max-width: 800px)').matches) {
    const mainForm = document.querySelector('[data-product-form]');
    const btn = sticky.querySelector('[data-sticky-atc-btn]');
    const atcObserver = new IntersectionObserver(entries => { sticky.setAttribute('data-visible', String(entries[0].isIntersecting)); }, { threshold: 0 });
    if (mainForm) atcObserver.observe(mainForm);
    if (btn && mainForm) btn.addEventListener('click', () => mainForm.requestSubmit());
    window.matchMedia('(max-width: 800px)').addEventListener('change', event => { if (!event.matches) sticky.setAttribute('data-visible', 'false'); });
  }
})();
